<template>
  <div class="card">
    <header class="card-header">
      <p class="card-header-title">Faiba Mkononi Password Recovery </p>
    </header>
    <div class="card-content">
      <div class="content">
        <h3>Enter Your Email</h3>
        <p>Submit your email to reset your password. A code will be sent to your Inbox</p>
        <form @submit.prevent="onSubmit">
          <div class="field">
            <label class="label">Email</label>
            <div class="control">
              <input v-model="userInfo.email" class="input" name="email" type="email" required>
              <p
                  class="help"
                  :class="{'is-danger':errors.email,'is-hidden':!errors.email}"
                  v-text="errors.email"
              ></p>
            </div>

          </div>

          <div class="sub_btn_container">
            <div class="control">
              <button
                  id="submit"
                  type="submit"
                  class="button is-primary"
                  :class="{'is-loading':isLoading}"
              >Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import axios from "axios";
import alertify from "alertifyjs";

export default {
  name: "ForgotPassword",
  data: function () {
    return {
      userInfo: {
        email: ''
      },
      isLoading: false,
      errors:{
        'email': ''
      }
    }
  },
  methods: {
    ...mapActions([]),
    onSubmit() {
      this.isLoading = true
      let self = this
      //console.log("submitting")
      if (self.validEmail(self.userInfo.email)){
        axios.post("/api/client/changepassreq", self.userInfo)
            .then(response=>{
              self.isLoading = false
              let body = response.data
              if (body.success){
                alertify.success(body.message)
                self.$router.push('/VerifyCode')
              }else {
                alertify.error(body.message)
              }
            })
            .catch(error =>{
              self.isLoading = false
              console.log(error);
              alertify.error(
                  "Error Occurred"+
                  "Internal Server Error Contact admin")
            })
      }else if (!self.validEmail(self.userInfo.email)){
        self.errors['email'] = 'valid email required'
      }

    },
    validEmail: function (email) {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
}
</script>

<style scoped>
template {
  justify-content: center;
}

.card {
  margin: 1rem;
  max-width: 35rem;
}

.card-header {
  background-color: #00b89c;
}

.card-header-title {
  justify-content: center;
  color: #ffffff;
}

.not-shown {
  visibility: hidden;
}
</style>